import { ClimateProtectionBehavior } from "@/types";

export const CLIMATE_PROTECTION_BEHAVIOR_LABELS: Record<
  ClimateProtectionBehavior,
  string
> = {
  safety_heat: "Safety Heat",
  safety_cool: "Safety Cool",
  safety_humidity: "Safety Humidity",
};

export function climateProtectionBehaviorLabels(
  behaviors: ClimateProtectionBehavior[] = []
): string[] {
  return behaviors.map(
    (behavior) => CLIMATE_PROTECTION_BEHAVIOR_LABELS[behavior] ?? behavior
  );
}

/**
 * Formats a configured threshold for display. Heat/cool thresholds are
 * temperatures and render with a degree symbol; humidity renders as a percent.
 * Mirrors how thermostat setpoints and humidity are shown elsewhere in the app
 * (see device-attribute-components/Value.tsx).
 */
export function formatClimateProtectionThreshold(
  behavior: ClimateProtectionBehavior,
  value: number | null | undefined
): string | null {
  if (value === null || value === undefined) {
    return null;
  }

  return behavior === "safety_humidity" ? `${value}%` : `${value}°`;
}

/**
 * Formats a `maximum_runtime_minutes` value for display. A value of 0 means the
 * property is relying on the system default rather than "no runtime", so it is
 * rendered as "Default (30 min)" instead of "0 minutes".
 */
export function formatClimateProtectionRuntime(
  minutes: number | null | undefined
): string | null {
  if (minutes === null || minutes === undefined) {
    return null;
  }

  if (minutes === 0) {
    return "Default (30 min)";
  }

  return `${minutes} minute${minutes === 1 ? "" : "s"}`;
}
